import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import checkCircleSVG from "images/icons/check_circle.svg";

export const CheckCircleIcon = (props: IconProps) => {
  return <IconBase {...props} href={checkCircleSVG} />;
};
